// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIolCLoop_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9985 10.7532C22.0349 9.12145 21.5134 6.92449 19.972 3.99988H22.2121C23.5095 6.69235 24.0394 8.92941 23.9978 10.7973C23.9428 13.2673 22.8898 14.9971 21.5031 16.1626C20.1502 17.2999 18.5154 17.8743 17.27 18.1689C16.7287 18.297 16.2463 18.3756 15.8704 18.4238C14.7406 19.1065 13.4162 19.4994 12.0001 19.4994C7.86011 19.4994 4.50397 16.1416 4.50397 11.9996C4.50397 10.6763 4.84654 9.43302 5.4478 8.35372C4.86367 8.61165 4.28921 8.94338 3.78355 9.36852C2.79964 10.1958 2.04275 11.3998 2.00159 13.2477C1.96524 14.8794 2.48652 17.076 4.02731 19.9999H1.78735C0.490354 17.308 -0.0393404 15.0713 0.00226286 13.2036C0.0572863 10.7335 1.11031 9.00345 2.49687 7.83768C3.84975 6.70022 5.4846 6.12555 6.73 5.83068C7.27133 5.70251 7.75373 5.62381 8.12968 5.57558C9.25947 4.89277 10.5839 4.49986 12.0001 4.49986C16.1401 4.49986 19.4963 7.85762 19.4963 11.9996C19.4963 13.3233 19.1536 14.5668 18.552 15.6463C19.1363 15.3884 19.7109 15.0568 20.2167 14.6317C21.2005 13.8047 21.9574 12.6009 21.9985 10.7532ZM17.4964 11.9996C17.4964 15.038 15.0347 17.4995 12.0001 17.4995C8.96556 17.4995 6.50391 15.038 6.50391 11.9996C6.50391 8.96125 8.96556 6.4998 12.0001 6.4998C15.0347 6.4998 17.4964 8.96125 17.4964 11.9996Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedIolCLoop is a generated icon component.
 */
let IconMedIolCLoop = IconMedIolCLoop_1 = class IconMedIolCLoop extends IconBaseElement {
    render() {
        return html `${IconMedIolCLoop_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIolCLoop.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedIolCLoop = IconMedIolCLoop_1 = __decorate([
    customElement('zui-icon-med-iol-c-loop')
], IconMedIolCLoop);
export { IconMedIolCLoop };
